<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import service from '../../../../domain/leiloes/services'
  import BtnStatus from './BtnStatus.vue'
  import BtnStatusConfirmar from './ConfirmStatus'

  export default {
    components: {
      BtnStatus,
      BtnStatusConfirmar
    },
    nome: 'monitor-comitente',
    directives: {mask},
    data () {
      return {
        pendencias: null,
        pendenciasVisualizadas: []
      }
    },
    computed: {
      pendenciasFiltradas () {
        if (!this.pendencias) {
          return null
        }
        return this.pendencias.filter(p => !this.pendenciasVisualizadas.includes(p.id))
      }
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos as informações iniciais')
      this.$interval = setInterval(() => {
        this.load()
      }, 5000)
      this.load()
    },
    beforeDestroy () {
      window.clearInterval(this.$interval)
    },
    deactivated () {
      window.clearInterval(this.$interval)
      this.$destroy() // no keep-alive
    },
    watch: {},
    methods: {
      load () {
        service.pendenciasComitenteMonitor(this.$route.params.leilao)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.pendencias = response.data
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      },
      deletarAprovacao (id, p) {
        let confirmar = confirm('Você tem certeza que deseja reenviar a aprovação deste lote para o comitente?')
        if (!confirmar) {
          return
        }
        this.$loaderOverlay.open().message('Processando pedido')
        service.deleteAprovacaoComitente(id)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.visualizar(p)
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      },
      visualizar (p) {
        this.pendenciasVisualizadas.push(p.id)
      }
    }
  }
</script>

<template>
  <div>
    <div class="wrapper-md">
      <div class="row">
        <div class="col-md-3 col-sm-6 hover-items" v-for="p in pendenciasFiltradas">
          <div class="panel wrapper">
            <h1 class="m-t-none">Lote {{ p.lote.numero }}</h1>
            <h4 class="m-t-none">Comitente: {{ p.lote.comitente.pessoa.nome }}</h4>
            <span v-if="p.status === 1" class="btn btn-success btn-lg font-bold">Aprovado</span>
            <span v-if="p.status === 2" class="btn btn-danger btn-lg font-bold">Rejeitado</span>
            <span v-if="p.status === 0" class="btn btn-warning btn-lg font-bold">Condicional</span>
            <a class="btn btn-primary pull-right" @click="visualizar(p)"><i class="fa fa-eye m-r-xs"></i> Visualizei</a>
            <div class="show-hover text-danger"><a @click="deletarAprovacao(p.lote.id, p)">Reenviar para
              comitente</a></div>
          </div>
        </div>
      </div>
      <div v-if="!pendencias || pendenciasFiltradas.length === 0">
        Nenhuma interação até o momento
      </div>
      <div class="m-t" v-if="pendencias && pendencias.length > 0 && pendencias.length !== pendenciasFiltradas.length">
        <div class="m-b-xs">Você ocultou algumas pendencias por tê-las visualizado.</div>
        <a class="btn btn-primary" @click="pendenciasVisualizadas = []">Reativar pendencias ocultadas</a>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// MonitorComitente.vue?0f5168d0